AWS.config.region = 'ap-southeast-2';

const identityPoolId = "ap-southeast-2:b3d45558-9f66-455b-9d0e-191531e7be6e";

class AuthManager {
  constructor() {
    this.callbacks = [];
    this.credentials = null;
    this.isGuest = false;
  }

  onAuthChange(callback) {
    this.callbacks.push(callback);
  }

  notify(isAuthenticated) {
    this.callbacks.forEach(cb => cb(isAuthenticated));
  }

  async getCredentials() {
    if (!this.credentials || this.credentials.needsRefresh()) {
      this.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: identityPoolId
      });
      
      await new Promise((resolve, reject) => {
        this.credentials.refresh(err => {
          if (err) {
            reject(err);
          } else {
            this.isGuest = true;
            resolve();
          }
        });
      });
    }
    return this.credentials;
  }

  async isAuthenticated() {
    try {
      await this.getCredentials();
      return true;
    } catch (err) {
      return false;
    }
  }

  getCurrentUser() {
    return this.isGuest ? { id: 'guest' } : null;
  }
}

const auth = new AuthManager();

export const getCurrentUser = () => auth.getCurrentUser();
export const getCredentials = () => auth.getCredentials();
export const isAuthenticated = () => auth.isAuthenticated();
export const onAuthChange = (callback) => auth.onAuthChange(callback);

export default auth;